import "../css/widgettable.css";
import Table from "@mui/material/Table";
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Spinner } from "react-bootstrap"

//firebase
import { useState, useEffect } from "react";
import { db } from "../firestore-db";
import 'firebase/compat/firestore';
import {
    collection,
    getDocs,
    updateDoc,
    deleteDoc,
    doc,
} from "firebase/firestore";

import * as MdIcons from "react-icons/md";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.common.white,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const List = () => {

    const [loading, setLoading] = useState(false)
    const [userStats, setUserStat] = useState([]);
    const statCollectionRef = db.collection("tutorBookingProfile");

    const updateUser = async (id, age) => {
        const userDoc = doc(db, "users", id);
        const newFields = { age: age + 1 };
        await updateDoc(userDoc, newFields);
    };

    const deleteUser = async (id) => {
        const userDoc = doc(db, "users", id);
        await deleteDoc(userDoc);
    };

    // get user data
    useEffect(() => {
        const getUsers = async () => {
            setLoading(true);
            const data = await getDocs(statCollectionRef.where("sessionStatus", "==", "Available"));

            setUserStat(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));

            setTimeout(() => {
                setLoading(false)
            }, 1100);
        };

        getUsers();
    }, []);

    return (
        <>
            {
                loading ?

                    <div className="loader">
                        <Spinner animation="grow" variant="primary" />
                    </div>

                    :

                    <TableContainer component={Paper} className="widget-table ">
                        <Table stickyHeader sx={{ minWidth: 650 }} aria-label="sticky table">
                            <TableHead className="tableHeader">
                                <StyledTableRow>
                                    <StyledTableCell className="tableCell"> Name </StyledTableCell>
                                    <StyledTableCell className="tableCell"> Date Registered </StyledTableCell>
                                    <StyledTableCell className="tableCell"> Education </StyledTableCell>
                                    <StyledTableCell className="tableCell"> Tutoring Subject </StyledTableCell>
                                    <StyledTableCell className="tableCell"> Tutoring Location </StyledTableCell>
                                    <StyledTableCell className="tableCell"> Status </StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>

                                {userStats.map((userStat) => (
                                    <StyledTableRow hover key={userStat.id}>

                                        <TableCell className="tableCell">
                                            {/* <img src={row.img} alt="" className="image" /> */}
                                            <div className="cellWrapper"> {userStat.tutorName} </div>
                                        </TableCell>

                                        <TableCell className="tableCell">{userStat.dateJoined}</TableCell>
                                        <TableCell className="tableCell">{userStat.tutorEduc}</TableCell>
                                        <TableCell className="tableCell">{userStat.selSubject}</TableCell>
                                        <TableCell className="tableCell">{userStat.city}, {userStat.province}</TableCell>

                                        <TableCell className="tableCell">
                                            <span className='widget-status'>
                                                {userStat.sessionStatus}
                                            </span>
                                        </TableCell>

                                    </StyledTableRow>
                                ))}

                            </TableBody>
                        </Table>
                    </TableContainer>

            }
        </>
    );
};

export default List;